<section class="app__section h-100">
  <favie-main-layout [sidebarLogo]="sidebarLogo" [sidebarItems]="sidebarItems">
    <favie-web-admin-header
      header
      [input]="headerInput"
    ></favie-web-admin-header>

    <ng-container content>
      <router-outlet></router-outlet>
    </ng-container>
  </favie-main-layout>
</section>
